import Repository from '../axios'
import {defaultPagination} from "../constants/config";

const  resource = "/admin";

export default {
    getListOfSettings() {
        return Repository.get(`${resource}/settings`)
    },
    updateSettings(payload){
        return Repository.post(`${resource}/settings`, payload)
    },
    getTheItem(item){
      return Repository.get(`${resource}/settings/item?item=${item}`)
    },
    updateCurrency(id, payload) {
      return Repository.put(`${resource}/system_setting/currencies/${id}`, payload)
    },
    getWorkOrderTimes() {
      return Repository.get(`${resource}/system_setting/work-order-times?is_paginate=0`)
    },
    getSingleWorkOrderTime(id) {
      return Repository.get(`${resource}/system_setting/work-order-times/${id}`)
    },
    createWorkOrderTime(payload) {
      return Repository.post(`${resource}/system_setting/work-order-times`, payload)
    },
    updateWorkOrderTime(id, payload) {
      return Repository.put(`${resource}/system_setting/work-order-times/${id}`, payload)
    }
};
